import { useCallback } from 'react';
import { useUpdateAnimal } from './useUpdateAnimal';

export const useArchiveAnimal = () => {
  const { updateAnimal, updateAnimalLoading, updateAnimalError } = useUpdateAnimal();

  const archiveAnimal = useCallback(
    async (animalId?: number) => {
      if (!animalId) return;
      return updateAnimal({
        variables: {
          animalId,
          data: {
            archived: { set: true },
          },
        },
      });
    },
    [updateAnimal],
  );

  return {
    archiveAnimalLoading: updateAnimalLoading,
    archiveAnimalError: updateAnimalError,
    archiveAnimal,
  };
};
